import { createNamespacedHelpers } from "vuex";
const userVuex = createNamespacedHelpers("user");
export default {
  name: "mLoginRewards",
  computed: {
    ...userVuex.mapState(["isLogin", "rewards"]),
    isRewardRankGiftShard() {
      const r = this.rewards || {};
      const giftshard = Number(r.giftshard) || 0;
      return giftshard > 0;
    },
    filteredRewards() {
      const r = this.rewards || {};
      const allowKeys = ["coin", "spins", "airdrop_ticket", "stock"];
      return Object.fromEntries(Object.entries(r).filter(([key]) => allowKeys.includes(key)));
    }
  },
  data() {
    return {
      popLoginRewardShow: false
    };
  },
  watch: {
    isLogin: {
      async handler(bool) {
        if (bool) {
          console.log("this.rewards", this.rewards);
          if (this.rewards && (this.rewards.coin > 0 || this.rewards.spins > 0 || this.rewards.airdrop_ticket > 0 || this.rewards.stock > 0 || this.rewards.giftshard > 0)) {
            this.popLoginRewardShow = true;
          }
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    ...userVuex.mapMutations(["setRewards"]),
    doLoginReward(type) {
      this.popLoginRewardShow = false;
      if (type == 'close') {
        this.setRewards(null);
        return;
      }
      // this.$nextTick(() => {
      //   if (this.isRewardRankGiftShard) {
      //     this.setRewards(null);
      //     this.$router.push(`/ranks`);
      //     return;
      //   }
      //   this.setRewards(null);
      //   this.$router.push(`/botcode`);
      // });
    }
  },

  mounted() {}
};